module.exports = __webpack_public_path__ + "static/media/flight-icon.def6b3a2.svg";